import { Modal } from "react-bootstrap"

export default function ErrorModal(props) {
    let nonErrorPadding = props.errorModal.IsError ? "" : "py-4";
    return (
        <Modal show={props.errorModal.IsShown}>
            { props.errorModal.IsError &&
                <div className="modal-header">
                    <h1 className="modal-title fs-5 text-danger">Error</h1>
                    <button type="button" className="btn-close" aria-label="Close" onClick={props.handleCloseErrorModal}></button>
                </div>
            }
            <Modal.Body>
                <div className={`col-sm-10 offset-sm-1 text-center my-4 ${nonErrorPadding}`}>
                    <span>{props.errorModal.Message}</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex mx-auto">
                    <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleCloseErrorModal}>
                        Ok
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    ) 
}